export const DEFAULT_MAP_OPTIONS = {
    mapTypeControl: false,
    streetViewControl: false,
    zoomControl: false,
    fullscreenControl: false,
    gestureHandling: 'cooperative',
    styles: [
        {
            featureType: 'poi',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
    ],
};
export const INITIAL_CENTER = {
    lat: 54.10977815949795,
    lng: 21.051393059374988,
};
export const INITIAL_ZOOM = 3;
export const PRESELECTED_MARKER_ZOOM = 12;
export const CLUSTER_CLASS_NAME = 'cluster-container';
export const clusterOptions = {
    clusterClass: CLUSTER_CLASS_NAME,
};
export const infoWindowDefaultOptions = {
    minWidth: 340,
    maxWidth: 340,
};
